export const COPY_ROLE_ID = 1;

export const COPY_CELL = "tt-copy-cell";

export const COPY_EXCLUDE = "tt-copy-exclude";

export const GUARD_CLASS = "tt-copy-guard";

export const ALLOW_CLASS = "tt-copy-allow";

const asElement = (node: Node | null): Element | null =>
  node == null
    ? null
    : node.nodeType === Node.ELEMENT_NODE
      ? (node as Element)
      : node.parentElement;

export function isCopyableSelection(): boolean {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
    return false;
  }

  for (let i = 0; i < selection.rangeCount; i++) {
    const range = selection.getRangeAt(i);
    if (range.collapsed) continue;
    const el = asElement(range.commonAncestorContainer);
    if (!el?.closest(`td.${COPY_CELL}`)) return false;
  }

  return selection.toString().trim().length > 0;
}
